<template>
    <div class="dashboard_contents">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="dashboard_title_area">
                        <div class="dashboard__title">
                            <h3>{{$store.getters.t('user_settings_account_settings')}}</h3>
                        </div>
                    </div>
                </div>
                <!-- end /.col-md-12 -->
            </div>
            <!-- end /.row -->

            <form action="#" class="setting_form">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="upload_modules">
                            <div class="modules__title">
                                <h3>{{$store.getters.t('user_settings_personal_data')}}</h3>
                            </div>

                            <div class="modules__content">
                                <div class="form-group">
                                    <label for="name">{{$store.getters.t('user_settings_your_first_last_name')}}</label>
                                    <input type="text" id="name" class="form-control" v-model="$v.userName.$model"
                                           value="">
                                    <div class="field-error-text" v-if="$v.userName.$error">{{$store.getters.t('user_settings_check_field')}}</div>
                                </div>
                                <div class="alert alert-success" role="alert" v-if="editFields.indexOf('name') !== -1">
                                    <span class="alert_icon lnr lnr-checkmark-circle"></span>
                                    <strong>{{$store.getters.t('user_settings_edited')}} </strong>
                                </div>

                                <div class="form-group">
                                    <label for="user_about">{{$store.getters.t('user_settings_short_info_about_you')}}</label>
                                    <textarea id="user_about" class="form-control"
                                              v-model="$v.userAbout.$model"></textarea>
                                    <div class="field-error-text" v-if="$v.userAbout.$error">{{$store.getters.t('user_settings_check_field')}}</div>
                                </div>
                                <div class="alert alert-success" role="alert" v-if="editFields.indexOf('about') !== -1">
                                    <span class="alert_icon lnr lnr-checkmark-circle"></span>
                                    <strong>{{$store.getters.t('user_settings_edited')}} </strong>
                                </div>
                                <div class="form-group">
                                    <label for="city_id">{{$store.getters.t('user_settings_locality')}}</label>
                                    <div class="" style="position:relative;">
                                        <input v-model="citySearch" class="form-control"
                                               :placeholder="$store.getters.t('user_settings_start_typing_locality')"/>
                                        <input type="hidden" name="city_id" id="city_id" v-model="city_id"
                                               class="form-control"/>
                                        <div class="search-result" v-if="cities.length">
                                            <div class="city-item" v-for="city in cities" @click="setCityId(city)">
                                                {{ city.name }}
                                            </div>
                                        </div>
                                        <div class="search-result"
                                             v-if="!cities.length && citySearch && citySearch !== citySelected">
                                            <div class="city-item">{{$store.getters.t('user_settings_nothing_found')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="alert alert-success" role="alert" v-if="editFields.indexOf('city')!==-1">
                                    <span class="alert_icon lnr lnr-checkmark-circle"></span>
                                    <strong>{{$store.getters.t('user_settings_edited')}} </strong>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group radio-group">
                                            <p class="label">{{$store.getters.t('user_settings_show_phone_number')}}</p>
                                            <div class="custom-radio">
                                                <input type="radio" id="yes" class="" v-model="userDisplayPhone"
                                                       value="1">
                                                <label for="yes">
                                                    <span class="circle"></span>{{$store.getters.t('user_settings_yes')}}
                                                </label>
                                            </div>

                                            <div class="custom-radio">
                                                <input type="radio" id="no" class="" v-model="userDisplayPhone"
                                                       value="0">
                                                <label for="no">
                                                    <span class="circle"></span>{{$store.getters.t('user_settings_no')}}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="alert alert-success" role="alert"
                                             v-if="editFields.indexOf('display_phone') !== -1">
                                            <span class="alert_icon lnr lnr-checkmark-circle"></span>
                                            <strong>{{$store.getters.t('user_settings_edited')}} </strong>
                                        </div>
                                    </div>
                                    <!-- end /.col-md-6 -->

                                    <div class="col-md-6">
                                        <div class="form-group radio-group">
                                            <p class="label">{{$store.getters.t('user_settings_show_email')}}</p>
                                            <div class="custom-radio">
                                                <input type="radio" id="ryes" class="" v-model="userDisplayEmail"
                                                       value="1">
                                                <label for="ryes">
                                                    <span class="circle"></span>{{$store.getters.t('user_settings_yes')}}
                                                </label>
                                            </div>

                                            <div class="custom-radio">
                                                <input type="radio" id="rno" class="" v-model="userDisplayEmail"
                                                       value="0">
                                                <label for="rno">
                                                    <span class="circle"></span>{{$store.getters.t('user_settings_no')}}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="alert alert-success" role="alert"
                                             v-if="editFields.indexOf('display_email')!==-1">
                                            <span class="alert_icon lnr lnr-checkmark-circle"></span>
                                            <strong>{{$store.getters.t('user_settings_edited')}} </strong>
                                        </div>
                                    </div>
                                    <!-- end /.col-md-6 -->
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <p class="label">{{$store.getters.t('user_settings_user_role')}}</p>
                                            <div class="custom-radio">
                                                <input type="radio" id="role_zooprotect" v-model="$v.role.$model"
                                                       value="zooprotection_org_owner">
                                                <label for="role_zooprotect">
                                                    <span class="circle"></span>{{$store.getters.t('user_settings_role_org_owner')}}
                                                </label>
                                            </div>

                                            <div class="custom-radio">
                                                <input type="radio" id="volunteer" v-model="$v.role.$model"
                                                       value="volunteer">
                                                <label for="volunteer">
                                                    <span class="circle"></span>{{$store.getters.t('user_settings_role_volunteer')}}
                                                </label>
                                            </div>
                                            <div class="custom-radio">
                                                <input type="radio" id="donator_basic" v-model="$v.role.$model"
                                                       value="donator_basic">
                                                <label for="donator_basic">
                                                    <span class="circle"></span>{{$store.getters.t('user_settings_role_donor')}}
                                                </label>
                                            </div>
                                            <div class="field-error-text" v-if="!$v.role.isNull">
                                                {{$store.getters.t('user_settings_choose_role')}}
                                            </div>
                                            <div class="field-error-text"
                                                 v-if="!$v.role.custom && user.switch_role_abilities && user.switch_role_abilities[role] && user.switch_role_abilities[role].reason">
                                                {{ user.switch_role_abilities[role].reason }}
                                            </div>

                                        </div>
                                        <div class="alert alert-success" role="alert"
                                             v-if="editFields.indexOf('role') !== -1">
                                            <span class="alert_icon lnr lnr-checkmark-circle"></span>
                                            <strong>{{$store.getters.t('edited')}} </strong>
                                        </div>
                                    </div>
                                </div>


<!--                                <div class="form-group">
                                    <label for="password">Пароль</label>
                                    <input type="password" id="password" v-model="$v.formData.password.$model"
                                           class="form-control">
                                    <div class="field-error-text" v-if="$v.formData.password.$error">Проверьте
                                        правильность заполнения поля
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="password_confirmation">Подтверждение пароля</label>
                                    <input type="password" id="password_confirmation"
                                           v-model="$v.formData.password_confirmation.$model" class="form-control">
                                    <div class="field-error-text" v-if="$v.formData.password_confirmation.$error">
                                        Проверьте правильность заполнения поля
                                    </div>
                                    <div class="field-error-text" v-if="!$v.formData.password_confirmation.confirm">
                                        Пароли не совпадают
                                    </div>
                                </div>-->

                            </div>
                            <!-- end /.modules__content -->
                        </div>
                        <div class="col-md-12">
                            <div class="dashboard_setting_btn">
                                <button type="submit" class="btn btn--round btn--md mb-4" :disabled="$v.$invalid" @click.prevent="saveUserData">{{$store.getters.t('user_settings_save_changes')}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- end /.col-md-6 -->

                    <div class="col-lg-6">
                        <div class="information_module">
                            <a class="toggle_title" href="#collapse1" role="button" data-toggle="collapse"
                               aria-expanded="false" aria-controls="collapse1">
                                <h4>{{$store.getters.t('user_settings_avatar')}}</h4>
                            </a>

                            <div class="information__set profile_images toggle_module collapse show" id="collapse1">
                                <div class="information_wrapper">
                                    <div class="profile_image_area">
                                        <div class="preview" v-if="cropperImgSrc"
                                             style="width: 100px; height: 100px; overflow: hidden; border-radius: 50%; display: inline-block; vertical-align: middle;"></div>
                                        <img :src="userAvatar | convertImage('avatar')" v-if="userAvatar && !cropperImgSrc"
                                             style="width: 100px; height: 100px; overflow: hidden; border-radius: 50%; display: inline-block; vertical-align: middle;">
                                        <div v-if="!cropperImgSrc && !userAvatar && userName"
                                             class="avatar-with-letter">{{ userName[0] }}
                                        </div>
                                        <div class="img_info">
                                            <p class="bold">{{$store.getters.t('user_settings_profile_photo')}}</p>
                                            <p class="subtitle">{{$store.getters.t('user_settings_jpg_png_up_to_5mb')}}</p>
                                        </div>

                                        <label for="cover_photo" class="upload_btn">
                                            <input type="file" accept=".png,.jpeg,.jpg" id="cover_photo"
                                                   @change="processFile($event)">
                                            <span class="btn btn--sm btn--round"
                                                  aria-hidden="true">{{$store.getters.t('user_settings_upload_photo')}}</span>
                                        </label>
                                    </div>

                                    <template v-if="cropperImgSrc">

                                        <vue-cropper
                                            ref="cropper"
                                            :src="cropperImgSrc"

                                            :minCropBoxWidth="100"
                                            :minCropBoxHeight="100"

                                            alt="Source Image"
                                            :aspectRatio="1"
                                            :viewMode="1"

                                            dragMode="move"

                                            preview=".preview"
                                        >
                                        </vue-cropper>

                                        <div class="cropper-nav mt-3 d-flex">
                                            <button  class="btn btn--sm btn--round" @click.prevent="flip(true, false)">
                                                <img src="/assets/images/icons/flipH.svg" alt="">
                                            </button>
                                            <button class="btn btn--sm btn--round" @click.prevent="flip(false, true)">
                                                <img src="/assets/images/icons/flipV.svg" alt="">
                                            </button>
                                            <button class="btn btn--sm btn--round" @click.prevent="rotate(90)">
                                                <img src="/assets/images/icons/rotateF.svg" alt="">
                                            </button>
                                            <button  class="btn btn--sm btn--round" @click.prevent="rotate(-90)">
                                                <img src="/assets/images/icons/rotateB.svg" alt="">
                                            </button>
                                        </div>

                                        <span @click="cropperImgSrc = null" aria-hidden="true"
                                              class="btn btn--sm btn--round mt-3 ">{{$store.getters.t('user_settings_cancel')}}</span>
                                        <span @click="cropImage" aria-hidden="true"
                                              class="btn btn--sm btn--round mt-3 pull-right">{{$store.getters.t('user_settings_done')}}</span>

                                    </template>



                                </div>
                                <div class="alert alert-success" role="alert"
                                     v-if="editFields.indexOf('avatar') !== -1">
                                    <span class="alert_icon lnr lnr-checkmark-circle"></span>
                                    <strong>{{$store.getters.t('user_settings_photo_uploaded')}} </strong>
                                </div>
                            </div>
                        </div>
                        <div class="information_module">
                                <a class="toggle_title" href="#collapse2" role="button" data-toggle="collapse"
                                   aria-expanded="false" aria-controls="collapse2">
                                <h4 class="tooltip-cusom">
                                    <span>
                                        {{$store.getters.t('user_settings_verification_tooltip')}}
                                        <a href="/contacts">{{$store.getters.t('user_settings_contacts_link')}}</a>
                                    </span>
                                    {{$store.getters.t('user_settings_verification')}}
                                </h4>
                                </a>

                            <div class="information__set profile_images toggle_module collapse show" id="collapse2">
                                <div class="information_wrapper">
                                    <div class="prof_img_upload">
                                        <div class="">
                                            <!-- Успешно проверено -->
                                            <div class="alert alert-success" role="alert" v-if="+is_verified === 1">
                                                <span class="alert_icon lnr lnr-checkmark-circle"></span>
                                                <strong>{{$store.getters.t('user_settings_profile_verified')}}</strong>
                                            </div>
                                            <!-- На проверке -->
                                            <div class="alert alert-info" role="alert" v-if="+is_verified === 2">
                                                <span class="alert_icon lnr lnr-bullhorn"></span>
                                                <strong>{{$store.getters.t('user_settings_in_process_of_verification')}}</strong>
                                            </div>
                                            <!-- Отказ -->
                                            <div class="alert alert-danger" role="alert" v-if="+is_verified === 3">
                                                <span class="alert_icon lnr lnr-warning"></span>
                                                <strong>{{$store.getters.t('user_settings_verification_rejected')}}</strong>
                                            </div>
                                        </div>
                                        <template v-if="+is_verified === 0">
<!--                                            <img src="/assets/images/passport.png">-->
                                            <div class="upload_title">
                                                <button class="btn btn--round btn--md mb-4" @click.prevent="connectStripe">{{$store.getters.t('user_settings_start_connect')}}</button>
                                            </div>
                                        </template>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- end /.col-md-6 -->


                    <!-- end /.col-md-12 -->
                </div>
                <!-- end /.row -->
            </form>
            <!-- end /form -->
        </div>
        <!-- end /.container -->
    </div>
    <!-- end /.dashboard_menu_area -->
</template>

<script>
import {required, minLength, maxLength, sameAs, between, email} from 'vuelidate/lib/validators';

export default {
    data() {
        return {
            appRoutes: null,
            formData: {
                password: null,
                password_confirmation: null
            },
            cropperImgSrc: null,
            croppedImg: null,
            userData: null,
            citySearch: null,
            city_id: null,
            citySelected: null,
            cities: [],
            oldFields: {},
            editFields: []
        }
    },
    created() {
        this.appRoutes = window.appRoutes;
    },
    mounted() {
        this.oldFields = (({name, city, about, display_email, display_phone, role}) => (
            {name, city, about, display_email, display_phone, role}
        ))(this.user);

        if (this.oldFields.city) {
            this.city_id = this.oldFields.city.id;
            this.citySearch = this.citySelected = this.oldFields.city.name;
        }


    },
    computed: {
        user() {
            let data = (({name,city,about,display_email,display_phone,settings,role}) => (
                {name,city,about,display_email,display_phone,settings,role}
            ))(this.$store.getters.getUserData);

            return data
        },

        userName: {
            get() {
                return this.$store.getters.getUserName;
            },
            set(userName) {
                this.$store.commit('setUserName', userName);
            }
        },
        userCity: {
            get() {
                return this.$store.getters.getUserCity;
            },
            set(userCity) {
                this.$store.commit('setUserCity', userCity);
            }
        },
        userAvatar: {
            get() {
                return this.$store.getters.getUserAvatar;
            },
            set(avatar) {
                this.$store.commit('setUserAvatar', avatar);
            }
        },
        userAbout: {
            get() {
                return this.$store.getters.getUserAbout;
            },
            set(about) {
                this.$store.commit('setUserAbout', about);
            }
        },
        userDisplayPhone: {
            get() {
                return this.$store.getters.getDisplayPhone;
            },
            set(value) {
                this.$store.commit('setDisplayPhone', parseInt(value));
            }
        },
        userDisplayEmail: {
            get() {
                return this.$store.getters.getDisplayEmail;
            },
            set(value) {
                this.$store.commit('setDisplayEmail', parseInt(value));
            }
        },
        is_verified: { //0 - по умолчанию, 1 - проверено, 2 - на проверке, 3 - отказано
            get() {
                return this.$store.getters.getIsVerified;
            },
            set(value) {
                this.$store.commit('setIsVerified', value);
            }
        },

        role: {

            get() {
                return this.$store.getters.getUserRole;
            },

            set(value) {
                this.$store.commit('setUserRole', value);
            }

        }

    },
    methods: {
        connectStripe() {
            window.location.href = '/stripe/connect'
        },

        flip( _horizontal, _vertical ){

            const { scaleX, scaleY } = this.$refs.cropper.getImageData();

            if( _horizontal ){

                this.$refs.cropper.scaleX( scaleX === 1 ? -1 : 1 );

                return;
            }

            if( _vertical ){

                this.$refs.cropper.scaleY( scaleY === 1 ? -1 : 1 );

                return;
            }

        },
        rotate( _degree ){

            this.$refs.cropper.rotate( _degree )

        },

        saveUserData() {
            let self = this;
            self.editFields = [];
            let request = {
                'name': self.userName,
                'about': self.userAbout,
                'password': self.formData.password,
                'password_confirmation': self.formData.password_confirmation,
                'display_phone': self.userDisplayPhone,
                'display_email': self.userDisplayEmail,
                'role': this.role,
            };

            if (this.city_id && this.city_id >= 0) {
                request['city_id'] = this.city_id
            }


            axios.post('/api/user/update', request)
                .then(response => {
                    response = response.data;

                    if (response.success) {
                        self.$store.dispatch('loadUserDataFromServer');
                        self.formData.password = null;
                        self.formData.password_confirmation = null;

                        this.deepEqual(this.oldFields, this.user)
                    }

                })
                .catch((error) => {

                })
        },

        deepEqual(oldFields, stateFields){
            const oldKeys = Object.keys(oldFields)
            const stateKeys = Object.keys(stateFields)

            for (let _k of oldKeys) {

                const areObjects = ((oldFields[_k] != null && typeof oldFields[_k] === 'object') && (stateFields[_k] != null && typeof stateFields[_k] === 'object'));

                if (areObjects && _k === 'city' && oldFields[_k].id && stateFields[_k].id && oldFields[_k].id !== stateFields[_k].id) {
                    this.editFields.push(_k)
                }

                if(!areObjects && oldFields[_k] !== stateFields[_k]){
                    this.editFields.push(_k)
                }

            }

            this.oldFields = this.user

        },

        processDocument(e) {
            let self = this;
            const file = e.target.files[0];

            let data = new FormData();
            data.append('document', file);

            axios.post('/api/user/verification-document', data, {
                header: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        self.is_verified = 2;
                    } else {
                        alert(this.$store.getters.t('common_error_reload'));
                    }
                })
                .catch((error) => {

                })
                .then();
        },
        processFile(e) {
            const file = e.target.files[0];

            if (!file.type.includes("image/")) {
                alert(this.$store.getters.t('user_settings_select_image_file'));
                return;
            }

            if (typeof FileReader === "function") {
                const reader = new FileReader();

                reader.onload = event => {
                    this.cropperImgSrc = event.target.result;
                    if (this.$refs.cropper) {
                        this.$refs.cropper.replace(event.target.result);
                    }
                };

                reader.readAsDataURL(file);
            } else {
                alert(this.$store.getters.t('common_filereader_not_supported'));
            }
        },
        cropImage() {
            let self = this;

            this.croppedImg = this.$refs.cropper.getCroppedCanvas().toDataURL();

            let croppedCanvas;
            let roundedCanvas;
            let roundedImage;

            // Crop
            croppedCanvas = this.$refs.cropper.getCroppedCanvas();

            // Round
            roundedCanvas = self.getRoundedCanvas(croppedCanvas);

            // Show
            this.croppedImg = roundedCanvas.toDataURL('image/jpeg', 0.6)

            fetch(this.croppedImg).then(res => {
                res.blob().then(function (myBlob) {
                    let data = new FormData()
                    data.append('avatar', myBlob)

                    axios.post('/api/user/avatar', data, {
                        header: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                        .then(response => {
                            response = response.data;
                            if (response.success) {
                                self.cropperImgSrc = null;
                                self.$store.dispatch( 'loadUserDataFromServer' );
                                self.editFields.push('avatar');
                            } else {
                                alert(this.$store.getters.t('common_error_reload'));
                            }
                        })
                        .catch((error) => {

                        })
                        .then();
                });
            });
        },
        getRoundedCanvas(sourceCanvas) {
            let canvas = document.createElement('canvas');
            let context = canvas.getContext('2d');
            let width = sourceCanvas.width;
            let height = sourceCanvas.height;

            canvas.width = width;
            canvas.height = height;
            context.imageSmoothingEnabled = true;
            context.drawImage(sourceCanvas, 0, 0, width, height);
            context.globalCompositeOperation = 'destination-in';
            context.beginPath();
            context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
            context.fill();
            return canvas;
        },
        searchCities() {
            let self = this;
            let url = '/' + self.appRoutes['geo.searchCities'];

            axios.get(url, {
                params: {
                    searchValue: self.citySearch
                }
            })
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        self.cities = response.cities
                    } else {
                        alert(this.$store.getters.t('common_error_reload'));
                    }
                })
                .catch((error) => {

                })
                .then();
        },
        setCityId(city) {
            this.city_id = city.id;
            this.citySearch = city.name;
            this.citySelected = city.name;
            this.userCity = city;
            this.cities = [];
        },
    },
    watch: {
        citySearch(value) {
            if (!value) {
                this.citySelected = null;
                this.cities = [];
                this.city_id = null;
                return false;
            }

            if (value !== this.citySelected) {
                this.searchCities();
            }
        },
    },
    validations: {
        formData: {
            password: {
                minLength: minLength(8),
                maxLength: maxLength(50),
            },
            password_confirmation: {
                minLength: minLength(8),
                maxLength: maxLength(50),
                confirm(value) {
                    return value === this.formData.password;
                }
            },
        },
        userName: {
            required,
            minLength: minLength(1),
            maxLength: maxLength(50),
        },
        userAbout: {
            minLength: minLength(1),
            maxLength: maxLength(300),
        },

        role: {
            isNull: function (value) {
                return !!value
            },
            custom: function (value) {

                if (this.user && this.user.switch_role_abilities && this.user.switch_role_abilities[value]) {
                    return this.user.switch_role_abilities[value].available
                }

                return true

            }
        }

    }
}
</script>

<style lang="scss">
.cropper-view-box,
.cropper-face {
    border-radius: 50%;
    min-width: 100px;
    min-height: 100px;
}

.cropper-nav{
    justify-content: center;
    margin: 0 -5px;
    flex-wrap: wrap;

    .btn{
        margin: 5px 5px;

        &--sm{
            padding: 10px 20px;
            line-height: 1;
        }

    }
}


.avatar-with-letter {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    background-color: #7347c1;
    color: #ffffff;
    text-align: center;
    line-height: 105px;
    font-size: 3rem;
    text-transform: uppercase;
}

@media screen and(max-width: 768px) {
    .profile_images .upload_btn {
        float: unset;
        position: relative;
    }
    .profile_images input {
        width: 100%;
    }
}

.tooltip-cusom {
    position: relative;

    span {
        display: block;
        top: 100%;
        left: 0;
        position: absolute;
        background: #0674ec;
        font-size: 12px;
        color: #fff;
        padding: 10px 15px;
        border-radius: 5px;
        z-index: -1;
        opacity: 0;
        visibility: hidden;
        transition: opacity .2s ease;

        &::before {
            display: block;
            content: '';
            position: absolute;
            left: 20px;
            top: -5px;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;

            border-bottom: 5px solid #0674ec;
        }
    }

    a {
        color: #fff;
        transition: opacity .2s ease;

        &:hover {
            opacity: .8;
        }
    }

    &:hover {
        span {
            opacity: 1;
            z-index: 1;
            visibility: visible;
        }
    }
}

.search-result {
    position: absolute;
    background-color: white;
    padding: 10px;
    box-shadow: 0 0 5px 0 #ccc;
    width: 100%;
    z-index: 1;

    .city-item {
        cursor: pointer;
        padding: 5px 0;
    }

    .city-item:hover {
        color: #0674ec;
    }
}
</style>
